<div [ngClass]="styles.leftContent">
	<producer-video-controls layout="column" [ngClass]="styles.flexFullHeight" [controlsRow]="true"></producer-video-controls>
</div>
<div [ngClass]="styles.rightContent">
	<h2>
		<ng-container *ngIf="user.firstName; else noName">
			{{ 'Event_Producer_Setup_WelcomeUser' | translate: { '0': user.firstName } }}
		</ng-container>
		<ng-template #noName>
			{{ 'Event_Producer_Setup_WelcomeNoName' | translate }}
		</ng-template>
	</h2>

	<div>
		{{ 'Event_Producer_Setup_ProducedEvent' | translate }}
		<span [ngClass]="styles.learnMore" (click)="showLearnMore(learnMoreModal)">
			{{ 'Event_Producer_Setup_LearnMore' | translate }}
		</span>
	</div>

	<div>{{ 'Event_Producer_Setup_ConfigureMsg' | translate }}</div>

	<div>{{ 'Event_Producer_Setup_ClickBackstageMsg' | translate }}</div>

	<button type="button" (click)="submit()" vbBtnPrimary>
		{{ 'Event_Producer_Setup_GoBackstage' | translate }}
	</button>

	<div>{{ 'Event_Producer_Setup_BackstageInfo' | translate }}</div>
	<div>{{ 'Event_Producer_Setup_NoMobile' | translate }}</div>
</div>
<a href="https://storyset.com/people" [ngClass]="styles.artBy" class="theme-primary-txt" *ngIf="modalOpen" target="_blank">
	{{ 'Event_Producer_ArtBy' | translate: { '0': 'storyset' } }}
</a>

<ng-template #learnMoreModal>
	<div [ngClass]="styles.learnMoreHeader">
		<h4>{{ 'Event_Producer_PopUpHeader' | translate }}</h4>
		<button type="button" [attr.aria-label]="'Close' | translate" (click)="learnMoreModalRef?.hide()">
			&times;
		</button>
	</div>
	<div [ngClass]="styles.learnMoreBody">
		<div>
			{{ 'Event_Producer_PopUpLine1' | translate }}
		</div>
		<div>
			{{ 'Event_Producer_PopUpLine2' | translate }}
		</div>
	</div>
	<div [ngClass]="styles.learnMoreFooter">
		<img [alt]="" class="float-left" [src]="'/img/producer-1.png'"/>
		<button type="button" class="float-right" (click)="learnMoreModalRef?.hide()" vbBtnPrimary>
			{{ 'Close' | translate }}
		</button>
	</div>
</ng-template>
